import angular from 'angular'

import mySaleDisplay from './directives/display/mySaleDisplay'
import mySaleCreateForm from './directives/forms/mySaleCreateForm'
import mySaleEditForm from './directives/forms/mySaleEditForm'
import mySaleForm from './directives/forms/mySaleForm'
import mySaleSearchForm from './directives/forms/mySaleSearchForm'

import updateAllAxletreesModal from './modals/updateAllAxletrees.modal'

import saleAsk from './services/ask.service'
import saleData from './services/data.service'
import saleFormat from './services/format.service'
import saleGo from './services/go.service'
import saleLocal from './services/local.service'
import saleMetadata from './services/metadata.service'
import saleRequest from './services/request.service'
import saleResource from './services/resource.service'
import sale from './services/sale.service'
import computeWeight from './services/computeWeight.service'

import saleButtons from './resources/buttons.resource'
import saleLabels from './resources/labels.resource'
import saleFields from './resources/fields.resource'
import saleIcons from './resources/icons.resource'

const name = 'sale'

angular.module(name, [])
  .directive('mySaleDisplay', mySaleDisplay)
  .directive('mySaleCreateForm', mySaleCreateForm)
  .directive('mySaleEditForm', mySaleEditForm)
  .directive('mySaleForm', mySaleForm)
  .directive('mySaleSearchForm', mySaleSearchForm)

  .factory('updateAllAxletreesModal', updateAllAxletreesModal)

  .factory('saleAsk', saleAsk)
  .factory('saleData', saleData)
  .factory('saleFormat', saleFormat)
  .factory('saleGo', saleGo)
  .factory('saleLocal', saleLocal)
  .factory('saleMetadata', saleMetadata)
  .factory('saleRequest', saleRequest)
  .factory('saleResource', saleResource)
  .factory('$$sale', sale)
  .factory('computeWeight', computeWeight)

  .factory('saleButtons', saleButtons)
  .factory('saleLabels', saleLabels)
  .factory('saleFields', saleFields)
  .factory('saleIcons', saleIcons)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/sale.module.js